"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isQuoteRequest = exports.isOpesi = exports.getSellTaxesList = exports.getSellWhatsappMessage = exports.getPrintedSellFileName = exports.validateSellItems = exports.validateSellItem = exports.validateSellItemQuantity = exports.hasNoSellPrice = exports.getPriceWithTax = exports.isProductSelected = exports.getSellCommonEmptyState = exports.getSellEmptyItem = exports.sanitizeItemsCreateSell = exports.computeSellTotals = exports.calculateComposedPromoTotals = exports.computeItemSellPriceAndTaxesFE = exports.computeGenericItemSellPriceAndTaxes = exports.computeItemSellPriceAndTaxes = exports.calculateItemTaxes = exports.applySellDiscountsToPrice = exports.unifySellAndBranDiscounts = exports.resetCNDiscountsVirtualAmount = exports.setDefaultRevenue2Percentage = exports.recalculateItemsTaxPercentage = exports.recalculateTaxPercentage = exports.recalculateItemDiscountPercentage = exports.getCreditNoteTypeCode = exports.getOrderNumber = exports.getSellTypeCodePrefix = exports.getSellTypeCode = exports.getSellType = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _moment = _interopRequireDefault(require("moment"));

var _sharedUtilities = require("../shared-utilities");

var _productHelper = require("./product-helper");

var _Enums = require("../enums/Enums");

var _mapTaxToAfipEnum = require("./mapTaxToAfipEnum");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var MINIMUN_LEGAL_PRICE = (0, _sharedUtilities.din)(0); // console.log(din(3456.56).toFormat()) // the FN converts it to cents already

/**
 * Giving the state of a sell or quoteRequest it calculates the type
 * VENTA = venta normal, con iva y facturada en AFIP
 * VENTA2 = venta normal, con iva y facturada en AFIP pero no resta stock
 * y la ganancia refleja lo que gananmos de la venta de IVA.
 * PRESUPUESTO = presupuesto normal, con impuestos y no resta stock ni se factura
 * PRESUPUESTO2 = venta en negro, no se factura, ni tiene impuestos en absoluto y resta stock
 * @param {object} object containing opesi and isQuoteRequest props
 */

var getSellType = function getSellType(_ref) {
  var opesi = _ref.opesi,
      isQuoteRequest = _ref.isQuoteRequest;

  if (isQuoteRequest) {
    return opesi ? _Enums.EnumSellType.QUOTE_REQUEST2 : _Enums.EnumSellType.QUOTE_REQUEST;
  }

  return opesi ? _Enums.EnumSellType.SELL2 : _Enums.EnumSellType.SELL;
};
/**
 * Get the sellType as int code
 * @param {*} param0
 */


exports.getSellType = getSellType;

var getSellTypeCode = function getSellTypeCode(_ref2) {
  var opesi = _ref2.opesi,
      isQuoteRequest = _ref2.isQuoteRequest;

  if (isQuoteRequest) {
    return opesi ? '3' : '';
  }

  return opesi ? '2' : '1';
};

exports.getSellTypeCode = getSellTypeCode;

var getSellTypeCodePrefix = function getSellTypeCodePrefix(type) {
  if (type === _Enums.EnumSellType.QUOTE_REQUEST2) {
    return '333';
  } else if (type === _Enums.EnumSellType.SELL2) {
    return '222';
  } else if (type === _Enums.EnumSellType.QUOTE_REQUEST) {
    return '000';
  }

  return '001';
};

exports.getSellTypeCodePrefix = getSellTypeCodePrefix;

var getOrderNumber = function getOrderNumber(type, id) {
  var sellType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  if (!id) return '';
  var number = id.toString().padStart(8, 0);

  switch (type) {
    case 'SELL':
      return "".concat(getSellTypeCodePrefix(sellType), "-").concat(number);

    case 'CN':
      return "444-".concat(number);

    case 'SELL_REQUEST':
      return "555-".concat(number);
  }
};
/**
 * Get the credit note type as int code
 * @param {*} param0
 */


exports.getOrderNumber = getOrderNumber;

var getCreditNoteTypeCode = function getCreditNoteTypeCode(type) {
  switch (type) {
    case _Enums.EnumSellType.QUOTE_REQUEST2:
      return '3';

    case _Enums.EnumSellType.SELL:
      return '2';

    default:
      return '';
  }
};
/**
 *
 * @param {object} item
 */


exports.getCreditNoteTypeCode = getCreditNoteTypeCode;

var recalculateItemDiscountPercentage = function recalculateItemDiscountPercentage(item) {
  // discounted*100/originalPrice
  if (!item || !item.sellPriceNoTaxes || !item.totalDiscounted) return null;
  if (!(0, _sharedUtilities.isDineroObject)(item.totalDiscounted)) throw new Error('item.totalDiscounted SHOULD BE INSTANCE OF DINEROJS');
  var otherDiscounts = item.totalDiscounted.multiply(100).divide(item.sellPriceNoTaxes);
  return (0, _sharedUtilities.roundDin)(otherDiscounts);
};
/**
 * Retunrs a new tax array by applying taxPercentageToTake to each tax in the original array.
 * Ej> recalculateTaxPercentage([21],.5) = [10.5]
 * @param {array} taxes
 * @param {float} taxPercentageToTake
 */


exports.recalculateItemDiscountPercentage = recalculateItemDiscountPercentage;

var recalculateTaxPercentage = function recalculateTaxPercentage(taxes, taxPercentageToTake) {
  var result = [];

  if (taxes && taxes.length > 0) {
    if (!taxPercentageToTake && taxPercentageToTake !== 0) return taxes;
    result = taxes.map(function (v) {
      return {
        tax: parseFloat(v.tax) * taxPercentageToTake
      };
    });
  }

  return result;
};
/**
 * Dadoo que cdo se vende en cta2 a veces es sin iva, a veces con, este metodo aplicara el porcentaje seleccionado a utilizar
 * De esta forma, si el cliente elige, 100, 50 o 0, se recorrera cada tax del item y se reducira en el porcentaje antes dicho
 * @param {*} item
 * @param {*} taxPercentageToTake passed as %tax a usar/100, 100=1, 50=.5, 0=0
 */


exports.recalculateTaxPercentage = recalculateTaxPercentage;

var recalculateItemsTaxPercentage = function recalculateItemsTaxPercentage(items, taxPercentageToTake) {
  if (!items) return [];
  return items.map(function (v) {
    var item = _objectSpread({}, v); // clone it JIC


    item.productTaxes = recalculateTaxPercentage(item.productTaxesBkp, taxPercentageToTake);
    return item;
  });
};
/**
 * x defecto hacemos q la venta de iva sea a la mitad del impuesto q tiene el prod
 * dado que el 99% de las veces tiene un solo impuesto cargado y se vende a la mitad
 * @param {*} item
 */


exports.recalculateItemsTaxPercentage = recalculateItemsTaxPercentage;

var setDefaultRevenue2Percentage = function setDefaultRevenue2Percentage(items) {
  return items.map(function (v) {
    var item = _objectSpread({}, v); // clone it JIC


    if (item.productTaxes && item.productTaxes.length > 0) {
      item.revenue2 = parseFloat(item.productTaxes[0].tax / 2);
    } //  else {
    //      TODO PERMITIR ESTO???
    //     throw new Error('the article has more than one tax');
    // }


    return item;
  });
};

exports.setDefaultRevenue2Percentage = setDefaultRevenue2Percentage;

var resetCNDiscountsVirtualAmount = function resetCNDiscountsVirtualAmount(sellDiscounts) {
  if (!sellDiscounts) return [];
  var a = sellDiscounts.map(function (item) {
    var v = _objectSpread({}, item); // clone it JIC


    if (v.type === 'CREDIT_NOTE') {
      v.virtualAmount = (0, _sharedUtilities.din)(v.amount);
    }

    return v;
  });
  return a;
};
/**
 * PARA Simplicar los calculos, en vez de recorrer dos arrays, mezclo los descuentos de la marca seleccionados y
 * los de la venta es decir, notas de credito, cupones descuento, etc y los unificamos en un solo array
 * @param {*} sellDiscounts
 * @param {*} brand
 */


exports.resetCNDiscountsVirtualAmount = resetCNDiscountsVirtualAmount;

var unifySellAndBranDiscounts = function unifySellAndBranDiscounts(sellDiscounts, brand) {
  var discounts = sellDiscounts ? (0, _toConsumableArray2["default"])(sellDiscounts) : [];

  if (brand && brand.discounts) {
    // to simplify things, i utilize the same array to map the brand discounts
    discounts = [].concat((0, _toConsumableArray2["default"])(brand.discounts.filter(function (v) {
      return v.isSelected;
    })), (0, _toConsumableArray2["default"])(discounts));
  }

  return discounts;
};
/**
 * Dada una lista de descuentos y una cantidad, aplicamos estos descuentos al precio de venta
 * para obtener un nuevo precio total con descuento del item
 * Usamos el virtualAmount de los descuentos tipo credit note dado que a la nota de credito
 * le vamos descontando cada item para saber ctos podemos cubrir con ese descuento (como si fuera un pago)
 * (unitPrice - sellDiscounts) * quantity
 * RETURNS TOTAL AS DINERO OBJ
 * @param {dinero OBJ} unitPrice DINERO OBJ
 * @param {float} quantity
 * @param {array} sellDiscounts
 */


exports.unifySellAndBranDiscounts = unifySellAndBranDiscounts;

var applySellDiscountsToPrice = function applySellDiscountsToPrice(unitPrice, quantity) {
  var sellDiscounts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  if (!sellDiscounts) return unitPrice;
  if (!unitPrice) return _sharedUtilities.DINEROJS_ZERO;
  if (!(0, _sharedUtilities.isDineroObject)(unitPrice)) throw new Error('unitPrice SHOULD BE INSTANCE OF DINEROJS'); // aplico primero todos los tipos q son por % y dsp las CN xq sino la cuenta no da igual
  // si varias el órden de los descuentos en el array y no está bien

  sellDiscounts.filter(function (d) {
    return !d.type || d.type !== 'CREDIT_NOTE';
  }).forEach(function (disc) {
    if (disc.discount) {
      var perToSub = (0, _sharedUtilities.roundDin)((0, _sharedUtilities.din)(1).subtract((0, _sharedUtilities.din)(disc.discount / 100)));
      unitPrice = unitPrice.multiply(perToSub);
    }
  });
  sellDiscounts.filter(function (d) {
    return d.type === 'CREDIT_NOTE';
  }).forEach(function (disc) {
    if (disc.virtualAmount) {
      if (!(0, _sharedUtilities.isDineroObject)(disc.virtualAmount)) throw new Error('virtualAmount SHOULD BE INSTANCE OF DINEROJS'); // console.log(unitPrice.multiply(quantity).toRoundedUnit(4), 'unitpricemult');
      // console.log(disc.virtualAmount.toRoundedUnit(4), 'virtualam');

      var newUnitPrice;

      if (unitPrice.multiply(quantity).lessThanOrEqual(disc.virtualAmount)) {
        newUnitPrice = MINIMUN_LEGAL_PRICE;
      } else {
        newUnitPrice = unitPrice.multiply(quantity).subtract(disc.virtualAmount).divide(quantity);
      }

      disc.virtualAmount = disc.virtualAmount.subtract(unitPrice.multiply(quantity));

      if (disc.virtualAmount.lessThanOrEqual(_sharedUtilities.DINEROJS_ZERO)) {
        // if was the total, turn to 0
        disc.virtualAmount = _sharedUtilities.DINEROJS_ZERO;
      } // console.log(newUnitPrice.toRoundedUnit(4), 'discnewun');


      unitPrice = newUnitPrice;
    }
  });
  return unitPrice.lessThanOrEqual(_sharedUtilities.DINEROJS_ZERO) ? MINIMUN_LEGAL_PRICE : unitPrice;
};
/** Iterates for every tax applied to the item and sums the results of appliying each tax to the price
 * impuesto = precioSinIva * impuesto
 * @param {Dinero Obj} unitPrice
 * @param {array} productTaxes
 */


exports.applySellDiscountsToPrice = applySellDiscountsToPrice;

var calculateItemTaxes = function calculateItemTaxes(unitPrice) {
  var productTaxes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var totalTaxes = _sharedUtilities.DINEROJS_ZERO;

  if (productTaxes && unitPrice) {
    if (!(0, _sharedUtilities.isDineroObject)(unitPrice)) throw new Error('unitPrice SHOULD BE INSTANCE OF DINEROJS');
    productTaxes.forEach(function (v) {
      totalTaxes = totalTaxes.add(unitPrice.multiply(parseFloat(v.tax / 100)));
    });
  }

  return totalTaxes;
};
/** ALL VALUES ARE RETURNED AS DINERO OBJECT
 * recalculates the sellPrice of an item base on its discount and the sell discounts.
 * ATTETION! IT DOES NOT TAKE INTO ACCOUNT THE QUANTITY BEING SOLD, IT IS JUST THE PRICE TO ONLY ONE UNIT
 * 
 * return {
    unitPrice: unitPrice + totalTaxes,
    totalTaxes,
    unitPriceNoTax: unitPrice,
    totalDiscounted: itemSellPriceNoTaxes - unitPrice
  };
 * @param {float} quantity 
 * @param {float} itemDiscount 
 * @param {dinero obj} itemSellPriceNoTaxes 
 * @param {array} productTaxes 
 * @param {array} sellDiscounts 
 */


exports.calculateItemTaxes = calculateItemTaxes;

var computeItemSellPriceAndTaxes = function computeItemSellPriceAndTaxes(quantity, itemDiscount, itemSellPriceNoTaxes, productTaxes, sellDiscounts) {
  if (!itemSellPriceNoTaxes) {
    return {
      unitPrice: _sharedUtilities.DINEROJS_ZERO,
      totalTaxes: _sharedUtilities.DINEROJS_ZERO,
      totalDiscounted: _sharedUtilities.DINEROJS_ZERO
    };
  }

  if (!(0, _sharedUtilities.isDineroObject)(itemSellPriceNoTaxes)) {
    throw new Error('itemSellPriceNoTaxes SHOULD BE INSTANCE OF DINEROJS');
  }

  var discPer = parseFloat(itemDiscount ? 1 - itemDiscount / 100 : 1);
  var unitPrice = itemSellPriceNoTaxes.multiply(discPer); // discount from a simple promo

  unitPrice = applySellDiscountsToPrice(unitPrice, quantity, sellDiscounts);
  var totalTaxes = _sharedUtilities.DINEROJS_ZERO;

  if (productTaxes) {
    totalTaxes = totalTaxes.add(calculateItemTaxes(unitPrice, productTaxes));
  } // console.log(
  //   itemSellPriceNoTaxes.toRoundedUnit(4),
  //   unitPrice.toRoundedUnit(4),
  //   itemSellPriceNoTaxes.subtract(unitPrice).toRoundedUnit(4),
  //   '<<'
  // );


  return {
    unitPrice: unitPrice.add(totalTaxes),
    unitPriceNoTax: unitPrice,
    totalTaxes: totalTaxes,
    totalDiscounted: itemSellPriceNoTaxes.subtract(unitPrice)
  };
};
/** ALL VALUES ARE RETURNED AS DINERO OBJECT
 * recalculates the sellPrice of an item base on its discount and the sell discounts.
 * ATTETION! IT DOES NOT TAKE INTO ACCOUNT THE QUANTITY BEING SOLD, IT IS JUST THE PRICE TO ONLY ONE UNIT
 * 
 * return {
    unitPrice: unitPrice + totalTaxes,
    totalTaxes,
    totalDiscounted: itemSellPriceNoTaxes - unitPrice
  };
 * @param {float} quantity 
 * @param {float} itemDiscount 
 * @param {dinero obj} itemSellPriceNoTaxes 
 * @param {array} productTaxes 
 * @param {array} sellDiscounts 
 */


exports.computeItemSellPriceAndTaxes = computeItemSellPriceAndTaxes;

var computeGenericItemSellPriceAndTaxes = function computeGenericItemSellPriceAndTaxes(item, sellDiscounts) {
  if (!item) {
    return {
      unitPrice: _sharedUtilities.DINEROJS_ZERO,
      totalTaxes: _sharedUtilities.DINEROJS_ZERO,
      totalDiscounted: _sharedUtilities.DINEROJS_ZERO,
      total: item.total ? item.total : _sharedUtilities.DINEROJS_ZERO
    };
  }

  if (!item.isGenericItem && !item.isFromSellRequest) throw new Error('THE ITEM IS NOT GENERIC');
  var unitPrice;

  if (item.isGenericItem) {
    unitPrice = (0, _sharedUtilities.din)((0, _sharedUtilities.roundDin)((0, _sharedUtilities.din)(item.unitPriceGeneric || 0), 2));
  } else if (item.isFromSellRequest) {
    unitPrice = item.unitPriceGeneric || _sharedUtilities.DINEROJS_ZERO;
  }

  var hasTaxes = item.productTaxes && item.productTaxes.length > 0; // sellPrice/imp only if it has one tax

  var imp = hasTaxes ? 1 + item.productTaxes[0].tax / 100 : 1;
  var sellPriceNoTaxes = (0, _sharedUtilities.din)((0, _sharedUtilities.roundDin)((unitPrice || _sharedUtilities.DINEROJS_ZERO).divide(imp), 2));
  var unitPriceNoTaxDiscounted = applySellDiscountsToPrice(sellPriceNoTaxes, item.quantity, sellDiscounts);
  var total = unitPriceNoTaxDiscounted.multiply(imp).multiply(item.quantity);
  var discounted = sellPriceNoTaxes.subtract(unitPriceNoTaxDiscounted);
  return {
    unitPrice: unitPrice,
    sellPriceNoTaxes: sellPriceNoTaxes,
    totalTaxes: (0, _sharedUtilities.din)((0, _sharedUtilities.roundDin)(calculateItemTaxes(unitPriceNoTaxDiscounted, item.productTaxes), 2)),
    totalDiscounted: discounted.greaterThan((0, _sharedUtilities.din)(0.09)) ? discounted : _sharedUtilities.DINEROJS_ZERO,
    total: total
  };
};
/**
 * Recalculates the sellPrice of an item base on its discount and the
 * sell discounts. Returns the following object:
 * ALL VALUES RETURNED AS DINERO OBJECT
 * return {
        unitPrice: unitPrice + totalTaxes,
        unitPriceNoTax: unitPrice,
        totalTaxes,
        totalDiscounted: itemSellPriceNoTaxes - unitPrice
    };
 */


exports.computeGenericItemSellPriceAndTaxes = computeGenericItemSellPriceAndTaxes;

var computeItemSellPriceAndTaxesFE = function computeItemSellPriceAndTaxesFE(item, sellDiscounts) {
  //si el usuario pone el precio a mano, entonces ya tiene impuestos y descuentos
  var filteredBrand = item.dirtyPrice ? null : item.brand;
  var discounts = unifySellAndBranDiscounts(sellDiscounts, filteredBrand);
  return computeItemSellPriceAndTaxes(item.quantity, item.discount, (0, _sharedUtilities.din)(item.sellPriceNoTaxes), item.productTaxes, discounts);
};
/**
 * RETURNS TOTALS AS DINERO OBJ
 * HACEMOS LO MISMO DE UN ITEM NORMAL, SOLO QUE ITERANDO CADA ITEM DE LA PROMO
 * Obtenido el precio de venta como ((costo+ganancia)*cantidad)-descPromo,
 * Usamos el campo sellPriceNoTaxes dado q puede haber sido redondeado por el usuario
 * iteramos luego sobre los posibles descuentos q se aplicaron sobre esa venta para calcular ese renglon descontado
 * se hace asi dado q el impuesto de cada prod puede ser diferente. POr eso no se aplican directamente sobre el total
 * de la venta, porque si uno paga 21 de IVA no es lo mismo q otro q paga 10.5
 * @param {*} item
 * @param {*} sellDiscounts
 * @param {*} taxPercentageToTake
 */


exports.computeItemSellPriceAndTaxesFE = computeItemSellPriceAndTaxesFE;

var calculateComposedPromoTotals = function calculateComposedPromoTotals(item) {
  var sellDiscounts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var taxPercentageToTake = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var totalPromoNet = (0, _sharedUtilities.din)(0);
  var totalPromoDiscounted = (0, _sharedUtilities.din)(0);
  var totalPromo = (0, _sharedUtilities.din)(0);
  var totalPromoTaxes = (0, _sharedUtilities.din)(0);
  var promo = item.promo;
  var items = promo.items || promo.promoItems; // cross FE && BE compatibility

  var discount = promo.discount || +promo.discountPercentage; // cross FE && BE compatibility

  var promoInfo = [];

  for (var i = 0; i < items.length; i++) {
    var promoI = items[i]; // iteramos precioVentaRenglon = (((costo + ganancia) * cantidadRenglon)-descPromo) - * descuentoVenta

    var prod = promoI.product;
    var taxes = [];

    if (prod.productTaxes.length > 0) {
      taxes = recalculateTaxPercentage(prod.productTaxes, taxPercentageToTake);
    }

    var _computeItemSellPrice = computeItemSellPriceAndTaxes(item.quantity, discount, (0, _sharedUtilities.din)(prod.sellPriceNoTaxes), taxes, sellDiscounts),
        unitPrice = _computeItemSellPrice.unitPrice,
        totalTaxes = _computeItemSellPrice.totalTaxes,
        totalDiscounted = _computeItemSellPrice.totalDiscounted;

    totalPromo = totalPromo.add(unitPrice.multiply(promoI.quantity));
    totalPromoNet = totalPromoNet.add((0, _sharedUtilities.din)(prod.sellPriceNoTaxes).multiply(promoI.quantity));
    totalPromoTaxes = totalPromoTaxes.add(totalTaxes.multiply(promoI.quantity));
    totalPromoDiscounted = totalPromoDiscounted.add(totalDiscounted.multiply(promoI.quantity));
    var taxList = "".concat(taxes.map(function (t) {
      return t.tax;
    }).join(','));
    promoInfo.push({
      internalCode: prod.internalCode,
      name: prod.name,
      unitPrice: (0, _sharedUtilities.roundDin)(unitPrice),
      quantity: promoI.quantity,
      taxList: taxList
    });
  }

  return {
    totalPromo: totalPromo,
    totalPromoDiscounted: totalPromoDiscounted,
    totalPromoNet: totalPromoNet,
    totalPromoTaxes: totalPromoTaxes,
    promoInfo: promoInfo
  };
};
/**
 * ALL THE VALUES ARE RETURNED AS DINERO OBJ
 * Giving the discount list applied to a sell , we iterate the items and recalculated it price, total, taxes
 * and price discounted
 * @param {*} sellDiscounts list of discounts
 * @param {*} items list of sell items
 * @param {float} taxPercentageToTake
 */


exports.calculateComposedPromoTotals = calculateComposedPromoTotals;

var reApplyDiscountsToItemsFE = function reApplyDiscountsToItemsFE(items, sellDiscounts) {
  var taxPercentageToTake = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  sellDiscounts = resetCNDiscountsVirtualAmount(sellDiscounts);
  return items.map(function (item) {
    var v = _objectSpread({}, item); // clone it JIC


    var unitPrice = (0, _sharedUtilities.din)(0);
    var totalDiscounted = (0, _sharedUtilities.din)(0);
    var totalTaxes = (0, _sharedUtilities.din)(0);
    var isPromoItem = !!v.promoId;

    if (!isPromoItem) {
      var data;
      console.log();

      if (item.sellPriceNoTaxes || item.sellPriceNoTaxes === 0) {
        //si el usuario pone el precio a mano, entonces ya tiene impuestos y descuentos
        var filteredBrand = item.dirtyPrice ? null : item.brand;
        var discounts = unifySellAndBranDiscounts(sellDiscounts, filteredBrand);

        if (item.isGenericItem || item.dirtyPrice) {
          data = computeGenericItemSellPriceAndTaxes(item, discounts);
          v.sellPriceNoTaxes = (0, _sharedUtilities.roundDin)(data.sellPriceNoTaxes);
        } else {
          data = computeItemSellPriceAndTaxes(item.quantity, item.discount, (0, _sharedUtilities.din)(item.sellPriceNoTaxes), item.productTaxes, discounts);
        }

        unitPrice = data.unitPrice;
        totalDiscounted = data.totalDiscounted;
        totalTaxes = data.totalTaxes;
        v.total = unitPrice.multiply(v.quantity);
      }
    } else {
      if (item.sellPriceNoTaxes || item.sellPriceNoTaxes === 0) {
        // is promo
        var _calculateComposedPro = calculateComposedPromoTotals(v, sellDiscounts, taxPercentageToTake),
            totalPromo = _calculateComposedPro.totalPromo,
            totalPromoTaxes = _calculateComposedPro.totalPromoTaxes,
            totalPromoDiscounted = _calculateComposedPro.totalPromoDiscounted;

        unitPrice = totalPromo;
        totalDiscounted = totalPromoDiscounted;
        totalTaxes = totalPromoTaxes;
      }

      v.total = unitPrice.multiply(v.quantity);
    }

    v.totalTaxes = totalTaxes;
    v.totalDiscounted = totalDiscounted;
    v.unitPrice = unitPrice; // uso esta variable para almacenar el total descontado dado q la marca puede aplicar una lista

    v.totalDiscountPercentage = recalculateItemDiscountPercentage(v);
    return v;
  });
};
/**
 * ALL VALUES WILL BE RETURNED AS DINERO OBJ
 * Calculates the totalNet, i.e the price without taxes and discounts,
 * the total sell value, ie. price with taxes and discounts,
 * total taxes and total discounts for the sell
 * return {
    totalWithDiscount: total,
    totalNet,
    totalSellTaxes,
    totalSellDiscounted
};
*/


var computeSellTotals = function computeSellTotals(items, sellDiscounts, taxPercentageToTake) {
  items = reApplyDiscountsToItemsFE(items, sellDiscounts, taxPercentageToTake);
  var totalNet = (0, _sharedUtilities.din)(0);
  var totalWithDiscount = (0, _sharedUtilities.din)(0);
  var totalSellTaxes = (0, _sharedUtilities.din)(0);
  var totalSellDiscounted = (0, _sharedUtilities.din)(0);

  for (var i = 0; i < items.length; i++) {
    if (!(0, _sharedUtilities.isDineroObject)(items[i].total)) throw new Error('item.total SHOULD BE INSTANCE OF DINEROJS');
    if (!(0, _sharedUtilities.isDineroObject)(items[i].totalTaxes)) throw new Error('item.totalTaxes SHOULD BE INSTANCE OF DINEROJS');
    if (!(0, _sharedUtilities.isDineroObject)(items[i].totalDiscounted)) throw new Error('item.totalDiscounted SHOULD BE INSTANCE OF DINEROJS');
    totalWithDiscount = totalWithDiscount.add(items[i].total);

    if (items[i].sellPriceNoTaxes) {
      totalNet = totalNet.add((0, _sharedUtilities.din)(items[i].sellPriceNoTaxes).multiply(items[i].quantity));
    }

    if (items[i].totalTaxes) {
      totalSellTaxes = totalSellTaxes.add(items[i].totalTaxes.multiply(items[i].quantity));
    }

    if (items[i].totalDiscounted) {
      totalSellDiscounted = totalSellDiscounted.add(items[i].totalDiscounted.multiply(items[i].quantity));
    }
  }

  return {
    totalWithDiscount: totalWithDiscount,
    totalNet: totalNet,
    totalSellTaxes: totalSellTaxes,
    totalSellDiscounted: totalSellDiscounted,
    items: items
  };
};

exports.computeSellTotals = computeSellTotals;

var sanitizeItemsCreateSell = function sanitizeItemsCreateSell(items) {
  return items.map(function (i) {
    var newItem = _objectSpread({}, i);

    newItem.stock = newItem.product ? newItem.product.stock : null; // TODO PROMO

    delete newItem.sellPriceNoTaxes;
    delete newItem.productTaxes;
    delete newItem.productTaxesBkp;
    delete newItem.productName;
    delete newItem.totalDiscounted;
    delete newItem.totalTaxes;
    delete newItem.promo;
    delete newItem.product;
    delete newItem.coveredWithPrimary;
    delete newItem.unitPriceGeneric;
    newItem.unitPrice = (0, _sharedUtilities.roundDin)(newItem.unitPrice);
    newItem.total = (0, _sharedUtilities.roundDin)(newItem.total);
    return (0, _sharedUtilities.removeTypeNames)(newItem);
  });
};

exports.sanitizeItemsCreateSell = sanitizeItemsCreateSell;

var getSellEmptyItem = function getSellEmptyItem() {
  return {
    quantity: '',
    unitPrice: 0,
    sellPriceNoTaxes: 0,
    discount: '',
    total: 0
  };
};

exports.getSellEmptyItem = getSellEmptyItem;

var getSellCommonEmptyState = function getSellCommonEmptyState(opesi, isQuoteRequest) {
  return {
    selectedClient: null,
    totalNet: 0,
    totalWithDiscount: 0,
    totalSellTaxes: 0,
    totalSellDiscounted: 0,
    selectedDiscounts: [],
    selectedCreditNotes: [],
    // podria obviarse pero es facil
    openConfirmDialog: false,
    opesiTaxPercentageSelected: opesi && isQuoteRequest ? 0 : 1,
    createdAt: (0, _moment["default"])(),
    notes: ''
  };
};

exports.getSellCommonEmptyState = getSellCommonEmptyState;

var isProductSelected = function isProductSelected(item) {
  return !!(item.productId || item.promoId || false);
};

exports.isProductSelected = isProductSelected;

var getPriceWithTax = function getPriceWithTax(item) {
  if (item) {
    if (item.isGenericItem || item.dirtyPrice) {
      return item.unitPrice && item.unitPriceGeneric ? (0, _sharedUtilities.roundDin)(item.unitPrice) : _sharedUtilities.DINEROJS_ZERO;
    }
  }

  var priceWithTax = item.total;

  if (isProductSelected(item) && item.totalDiscountPercentage && item.quantity) {
    var per = 1 - item.totalDiscountPercentage / 100;

    if (per !== 0) {
      priceWithTax = item.total.divide(per);
    }
  }

  if (item.quantity && priceWithTax) {
    priceWithTax = priceWithTax.divide(item.quantity);
  }

  return (0, _sharedUtilities.roundDin)(priceWithTax);
};
/**
  prodOrPromoSelected AND (noSellPrice OR noCostPriceIfProduct) AND quantity
  and also is not full discount, that does not mean it has no sell price
   */


exports.getPriceWithTax = getPriceWithTax;

var hasNoSellPrice = function hasNoSellPrice(item) {
  return isProductSelected(item) && (!getPriceWithTax(item) || (item.productId ? !item.product.costPrice || item.product.costPrice == 0 : false)) && item.quantity && item.totalDiscountPercentage != 100;
};

exports.hasNoSellPrice = hasNoSellPrice;

var validateSellItemQuantity = function validateSellItemQuantity(quantity, stock) {
  if (!quantity || !stock) return false;

  if ((0, _productHelper.isItemCoveredWithPrimaryWarehouse)(quantity, stock)) {
    return true;
  }

  return quantity - (0, _productHelper.getTotalUnitsSelected)(stock) == 0;
};
/**
 * Thows an exception if something is not valid
 * @param {*} item a single sell item
 */


exports.validateSellItemQuantity = validateSellItemQuantity;

var validateSellItem = function validateSellItem(item, isQuoteRequest) {
  // warehouse validation
  var quantityValidation = validateSellItemQuantity(item.quantity, (item.product || {}).stock);

  if (!quantityValidation && !isQuoteRequest && !item.isGenericItem) {
    throw 'No se ha seleccionado el depósito';
  } // cost price validation


  if (hasNoSellPrice(item)) {
    if (!getPriceWithTax(item)) {
      throw new Error('ITEM SIN PRECIO VENTA');
    } else {
      throw new Error('ITEM SIN PRECIO COSTO');
    }
  }
}; // TODO NO SE SI ESTO ANDA BIEN CON PROMOS

/**
 * Thows an exception if something is not valid
 * @param {*} items
 * @param {*} sellType
 */


exports.validateSellItem = validateSellItem;

var validateSellItems = function validateSellItems(items, sellType) {
  if (!items) return false;
  var isQuoteRequest = sellType == _Enums.EnumSellType.QUOTE_REQUEST;
  items.map(function (item) {
    validateSellItem(item, isQuoteRequest);
  });
  return true;
};

exports.validateSellItems = validateSellItems;

var getPrintedSellFileName = function getPrintedSellFileName(sell, isSellRequest) {
  var withExtension = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (!sell) return '';
  var fileType = isSellRequest ? 'nota_venta' : sell.type !== _Enums.EnumSellType.QUOTE_REQUEST ? 'remito' : 'presupuesto';
  var sanitizedClient = (sell.client || {}).fullName.replace(' ', '_').toLowerCase().normalize('NFD').replace(/(?:[\^`\xA8\xAF\xB4\xB7\xB8\u02B0-\u034E\u0350-\u0357\u035D-\u0362\u0374\u0375\u037A\u0384\u0385\u0483-\u0487\u0559\u0591-\u05A1\u05A3-\u05BD\u05BF\u05C1\u05C2\u05C4\u064B-\u0652\u0657\u0658\u06DF\u06E0\u06E5\u06E6\u06EA-\u06EC\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F5\u0818\u0819\u0898-\u089F\u08C9-\u08D2\u08E3-\u08FE\u093C\u094D\u0951-\u0954\u0971\u09BC\u09CD\u0A3C\u0A4D\u0ABC\u0ACD\u0AFD-\u0AFF\u0B3C\u0B4D\u0B55\u0BCD\u0C3C\u0C4D\u0CBC\u0CCD\u0D3B\u0D3C\u0D4D\u0DCA\u0E47-\u0E4C\u0E4E\u0EBA\u0EC8-\u0ECC\u0F18\u0F19\u0F35\u0F37\u0F39\u0F3E\u0F3F\u0F82-\u0F84\u0F86\u0F87\u0FC6\u1037\u1039\u103A\u1063\u1064\u1069-\u106D\u1087-\u108D\u108F\u109A\u109B\u135D-\u135F\u1714\u1715\u17C9-\u17D3\u17DD\u1939-\u193B\u1A75-\u1A7C\u1A7F\u1AB0-\u1ABE\u1AC1-\u1ACB\u1B34\u1B44\u1B6B-\u1B73\u1BAA\u1BAB\u1C36\u1C37\u1C78-\u1C7D\u1CD0-\u1CE8\u1CED\u1CF4\u1CF7-\u1CF9\u1D2C-\u1D6A\u1DC4-\u1DCF\u1DF5-\u1DFF\u1FBD\u1FBF-\u1FC1\u1FCD-\u1FCF\u1FDD-\u1FDF\u1FED-\u1FEF\u1FFD\u1FFE\u2CEF-\u2CF1\u2E2F\u302A-\u302F\u3099-\u309C\u30FC\uA66F\uA67C\uA67D\uA67F\uA69C\uA69D\uA6F0\uA6F1\uA700-\uA721\uA788-\uA78A\uA7F8\uA7F9\uA8C4\uA8E0-\uA8F1\uA92B-\uA92E\uA953\uA9B3\uA9C0\uA9E5\uAA7B-\uAA7D\uAABF-\uAAC2\uAAF6\uAB5B-\uAB5F\uAB69-\uAB6B\uABEC\uABED\uFB1E\uFE20-\uFE2F\uFF3E\uFF40\uFF70\uFF9E\uFF9F\uFFE3]|\uD800\uDEE0|\uD801[\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDEE5\uDEE6]|\uD803[\uDD22-\uDD27\uDF46-\uDF50\uDF82-\uDF85]|\uD804[\uDC46\uDC70\uDCB9\uDCBA\uDD33\uDD34\uDD73\uDDC0\uDDCA-\uDDCC\uDE35\uDE36\uDEE9\uDEEA\uDF3C\uDF4D\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC42\uDC46\uDCC2\uDCC3\uDDBF\uDDC0\uDE3F\uDEB6\uDEB7\uDF2B]|\uD806[\uDC39\uDC3A\uDD3D\uDD3E\uDD43\uDDE0\uDE34\uDE47\uDE99]|\uD807[\uDC3F\uDD42\uDD44\uDD45\uDD97]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF8F-\uDF9F\uDFF0\uDFF1]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD833[\uDF00-\uDF2D\uDF30-\uDF46]|\uD834[\uDD67-\uDD69\uDD6D-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD]|\uD838[\uDD30-\uDD36\uDEAE\uDEEC-\uDEEF]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD46\uDD48-\uDD4A])/g, '');
  return "".concat(fileType, "_").concat(sanitizedClient, "_").concat(sell.orderNumber).concat(withExtension ? '.pdf' : '');
};

exports.getPrintedSellFileName = getPrintedSellFileName;

var getSellWhatsappMessage = function getSellWhatsappMessage(sell) {
  if (!sell || !sell.client) return '';
  var name = 'Ries Lubricantes';

  if (sell.type === _Enums.EnumSellType.QUOTE_REQUEST2 || sell.type === _Enums.EnumSellType.SELL2) {
    name = 'R. Lubricantes';
  }

  return "Hola ".concat(sell.client.firstName, "!\n  Te adjuntamos el comprabante de la venta ").concat(sell.orderNumber, ".\n  Podes descargarlo en ").concat(sell.printedOrderUrl, " durante 30 d\xEDas.\n  Saludos, ").concat(name, ".");
};

exports.getSellWhatsappMessage = getSellWhatsappMessage;

var getSellTaxesList = function getSellTaxesList(items, taxPercentageToTake) {
  var sellDiscounts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var taxMap = new Map();
  items.forEach(function (si) {
    if (si.productTaxes && si.sellPriceNoTaxes) {
      var _computeItemSellPrice2 = computeItemSellPriceAndTaxesFE(si, sellDiscounts),
          unitPriceNoTax = _computeItemSellPrice2.unitPriceNoTax;

      var newTaxes = recalculateTaxPercentage(si.productTaxesBkp, taxPercentageToTake);
      newTaxes.forEach(function (v) {
        var itemTaxKey = (0, _mapTaxToAfipEnum.mapTaxToAfipEnum)(v.tax);
        var taxesDin = unitPriceNoTax.multiply(si.quantity).multiply(parseFloat(v.tax / 100)); // console.log(itemTaxKey, roundDin(taxesDin));

        if (taxMap.has(itemTaxKey)) {
          var prev = taxMap.get(itemTaxKey);
          taxMap.set(itemTaxKey, prev.add(taxesDin));
        } else {
          taxMap.set(itemTaxKey, taxesDin);
        }
      });
    }
  });
  return (0, _toConsumableArray2["default"])(taxMap).map(function (i) {
    return {
      tax: i[0],
      amount: (0, _sharedUtilities.roundDin)(i[1])
    };
  });
};

exports.getSellTaxesList = getSellTaxesList;

var isOpesi = function isOpesi(sell) {
  return (sell === null || sell === void 0 ? void 0 : sell.type) === _Enums.EnumSellType.SELL2 || (sell === null || sell === void 0 ? void 0 : sell.type) === _Enums.EnumSellType.QUOTE_REQUEST2;
};

exports.isOpesi = isOpesi;

var isQuoteRequest = function isQuoteRequest(sell) {
  return (sell === null || sell === void 0 ? void 0 : sell.type) === _Enums.EnumSellType.QUOTE_REQUEST;
};

exports.isQuoteRequest = isQuoteRequest;